import React from 'react'
import { Helmet } from 'react-helmet'

const defaultBrand = ' | Mashup Garage Playbook'
const defaultTitle = 'Agile Software Development'
const defaultDescription = 'The Mashup Garage Playbook'

const seoTitle = headings => {
  return (headings[0] ? headings[0].value : defaultTitle) + defaultBrand
}

const SEO = ({ headings }) => {
  const ogDescription = seoTitle(headings) + ' ' + defaultDescription

  return (
    <Helmet>
      <title>{seoTitle(headings)}</title>
      <meta name='description' content={defaultDescription} />
      <meta
        name='keywords'
        content='software engineering, ruby on rails, elixir, react'
      />
      <meta property='og:description' conetent={ogDescription} />
      <meta name='twitter:description' conetent={defaultDescription} />
    </Helmet>
  )
}

SEO.defaultProps = {
  headings: []
}

export default SEO
